export default __webpack_public_path__ + "static/media/Newton_Fund.39226b5d.png";